import React from 'react';
import loadable from '@loadable/component';

const CreatedWithinFilter = loadable(
  () =>
    import(
      /* webpackChunkName: "CreatedWithinFilter.loadable" */ 'app/shared/modules/MobileSRP/Header/FilterModules/CreatedWithinFilter/component'
    ),
);

class LoadableCreatedWithinFilter extends React.Component {
  render() {
    return <CreatedWithinFilter {...this.props} />;
  }
}

export default LoadableCreatedWithinFilter;
